// extracted by mini-css-extract-plugin
export var activeLink = "footer-module--activeLink--e31f3";
export var address = "footer-module--address--82a3f";
export var col = "footer-module--col--9c356";
export var dark = "footer-module--dark--4f24f";
export var followText = "footer-module--followText--e0ea1";
export var footer = "footer-module--footer--363ee";
export var icon = "footer-module--icon--7309e";
export var leftAligned = "footer-module--left-aligned--157f1";
export var link = "footer-module--link--3ea39";
export var links = "footer-module--links--6cc59";
export var logo = "footer-module--logo--51dc1";
export var rightAligned = "footer-module--right-aligned--4a083";
export var row = "footer-module--row--bb6fe";
export var socialIcons = "footer-module--socialIcons--d86e6";